/** @clearscore/helpers.resolve-request v2.1.8: 2022-12-12 17:54 (assemble v5.5.1) **/
import { resolveProp } from '@clearscore/helpers.resolve-props';
import * as requestStatuses from '@clearscore/constants.request-statuses';
var getRequestStatus = function getRequestStatus(status, statusCode) {
  return {
    isInitial: status === requestStatuses.INITIAL,
    isPending: status === requestStatuses.PENDING,
    isComplete: status === requestStatuses.SUCCESS,
    hasFailed: status === requestStatuses.ERROR,
    statusCode: statusCode
  };
};
var calculateIsCompleteMultiple = function calculateIsCompleteMultiple(statusList) {
  if (statusList.every(function (status) {
    return status === requestStatuses.SUCCESS;
  })) return true;
  if (statusList.every(function (status) {
    return status === requestStatuses.ERROR;
  })) return false;
  return statusList.map(function (status) {
    return status === requestStatuses.SUCCESS || status === requestStatuses.ERROR;
  }).every(Boolean);
};
var getRequestStatusMultiple = function getRequestStatusMultiple() {
  var statusList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var statusCodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var hasStatuses = statusList.length;
  return {
    isInitial: hasStatuses ? statusList.every(function (status) {
      return status === requestStatuses.INITIAL;
    }) : true,
    isPending: statusList.some(function (status) {
      return status === requestStatuses.PENDING;
    }),
    isComplete: hasStatuses ? calculateIsCompleteMultiple(statusList) : false,
    hasFailed: hasStatuses ? statusList.every(function (status) {
      return status === requestStatuses.ERROR;
    }) : false,
    hasFailures: statusList.some(function (status) {
      return status === requestStatuses.ERROR;
    }),
    statusCodes: statusCodes
  };
};
var index = function index(state, prop) {
  var props = prop.split('.');
  var hasValidRootReducer = props.length === 1 ? state : state[props[0]];
  if (hasValidRootReducer) {
    return resolveProp(prop, state) || requestStatuses.INITIAL;
  }
  console.error("Cannot resolve root state for prop: ".concat(prop)); // eslint-disable-line no-console

  return requestStatuses.ERROR;
};
export { index as default, getRequestStatus, getRequestStatusMultiple };